module.exports = __webpack_public_path__ + "img/slide5.308314f3.jpg";